const materialBaseUrl = (import.meta.env.VITE_APP_MATERIAL_BASE_URL || '').trim().replace(/\/+$/, '');

/**
 * 将后端图片路径转换为仅供页面渲染的地址，不修改原始业务数据。
 */
export function resolveImageDisplayUrl(path: string): string;
export function resolveImageDisplayUrl<T extends null | undefined>(path: T): T;
export function resolveImageDisplayUrl(path: string | null | undefined): string | null | undefined {
  if (!path || /^(?:data|blob):/i.test(path)) return path;
  if (path.startsWith('//')) return `http:${path}`;
  if (!materialBaseUrl) return path;
  if (/^http:\/\/localhost:8888(?:\/|$)/i.test(path)) {
    return path.replace(/^http:\/\/localhost:8888/i, materialBaseUrl);
  }
  if (/^https?:\/\//i.test(path)) return path;

  const localPath = path.replace(/^\/stage-api(?=\/media(?:\/|$))/, '');
  return `${materialBaseUrl}/${localPath.replace(/^\/+/, '')}`;
}
